/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Sign_InInputs */



/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Landing_Sign_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const landing_sign_in = /** @type {((inputs?: Landing_Sign_InInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Sign_InInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se connecter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar sesión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entrar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi")
	return /** @type {LocalizedString} */ ("Sign in")
});